module.exports = __webpack_public_path__ + "static/media/team-member-02.b66bb1b1.jpg";